module.exports = __webpack_public_path__ + "static/media/04_andinvainthedreamer.e386450e.jpg";